import { getCartConfig, getCartTotal, getTotalQuantity, IDataLayerEcommerceItem, mapItems } from "./cart";
import { EDataLayerEventType, sendEvent } from "./dataLayer";
import { IStorage } from "@utils/storage";

export interface IDataLayerPurchaseEvent {
    event: EDataLayerEventType.PURCHASE;
    ecommerce: {
        items: IDataLayerEcommerceItem[];
        orderValue: number;
        totalQuantity: number;
    };
    cartConfig: string;
    transactionId: string;
}

export const sendPurchaseEvent = (storage: IStorage) => {
    const { cart, prospectReference } = storage;
    if (cart && prospectReference) {
        const items = mapItems(cart.offers);
        sendEvent({
            event: EDataLayerEventType.PURCHASE,
            ecommerce: {
                items,
                orderValue: getCartTotal(cart),
                totalQuantity: getTotalQuantity(items),
            },
            cartConfig: getCartConfig(items),
            transactionId: prospectReference,
        });
    }
};
